const createMoneyTokens = ({ fontSizes, fontWeights, colors }) => ({
  colors: colors.neutrals[0],
  fontWeights: {
    default: fontWeights.bold,
    strikeThrough: fontWeights.medium,
    tiny: fontWeights.bold,
  },
  fontSizes: {
    defaultPart: {
      tiny: 'unset',
      small: fontSizes.heading[0],
      medium: fontSizes.heading[1],
    },
    nonIntegerPart: {
      tiny: 'unset',
      small: fontSizes.body[3],
      medium: fontSizes.body[2],
    },
  },
});

export default createMoneyTokens;
